import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class EvaluationCriteria extends BaseService {
  constructor() {
    super("evaluation-criteria");
  }

  createEvaluationCriteria = (data) => getResponseQuery(super.insert(data));
  updateEvaluationCriteria = (evaluationCriteria) =>
    getResponseQuery(super.updateById(evaluationCriteria));

  updateOrderEvaluationCriteria = (enterpriseId, arrayEvalutionsCriteria) =>
    getResponseQuery(
      http.post(
        `${this.path}/update-order/${enterpriseId}`,
        arrayEvalutionsCriteria
      )
    );

  deleteEvaluationCriteria = (evaluationCriteriaId) =>
    getResponseQuery(super.deleteById(evaluationCriteriaId));
  duplicateEvaluationCriteria = (evaluationCriteria) =>
    getResponseQuery(http.put(`${this.path}/duplicate`, evaluationCriteria));
}

export default new EvaluationCriteria();
